import React from 'react';
import loginBg from '../assets/login_bg.png';
import SetPassword from '../components/SetPassword';
import '../css/Login.css';

const SetPasswordPage = () => {
  return (
    <div className="login-container">
      <div className="login-split-bg">
        <div className="login-panel login-panel-image">
          <img src={loginBg} alt="Set Password" />
          <div className="login-panel-caption">
            <h3>Üdvözlünk!</h3>
            <p>Állítsd be a jelszavadat a folytatáshoz.</p>
          </div>
        </div>
        <div className="login-panel login-panel-form">
          <SetPassword />
        </div>
      </div>
    </div>
  );
};

export default SetPasswordPage;
